/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { DialogDisclosure } from "@ariakit/react";
import {
  DialogTrigger,
  FormSubmitButton,
  LoadingIndicator,
  trackEvent,
  useCurrentUser,
} from "@indietabletop/appkit";
import type { ReactNode } from "react";
import { type CartProduct } from "../cart/cart.tsx";
import { type Product } from "../client.ts";
import { FathomEvent } from "../fathom.ts";
import { AccountNeededDialog } from "./AccountNeededDialog.tsx";

export function CheckoutButton(props: {
  products: (Product | CartProduct)[];
  backToIfAccountNeeded: string;
  redirectToIfAccountNeeded: string;
  children: ReactNode;
  className?: string;
}) {
  const {
    products,
    redirectToIfAccountNeeded,
    backToIfAccountNeeded,
    ...rest
  } = props;

  const currentUser = useCurrentUser();

  if (!currentUser) {
    return (
      <DialogTrigger>
        <AccountNeededDialog
          products={products}
          backTo={backToIfAccountNeeded}
          redirectTo={redirectToIfAccountNeeded}
        />
        <DialogDisclosure {...rest} />
      </DialogTrigger>
    );
  }

  return (
    <FormSubmitButton
      {...rest}
      disabled={!products.length}
      loading={<LoadingIndicator />}
      onClick={() => void trackEvent(FathomEvent.BUY)}
    />
  );
}
